<template>
  <div v-if="isVisible" v-loading="isLoading">
    <template v-if="!hasCreateNew">
      <form-editor-new
        class="m-4"
        :data="data"
        :model="formModel"
        @change="handleFormData"
        ref="Form"/>
    </template>
    <template v-else>
      <report-panel
        class="supplier-quotes-rfq2-editor__report-panel"
        :editorID="config.id"
        :filterID="data.supplierCompanyID"
        :isVisibleReports.sync="isVisibleReports"
        :activeTabReports.sync="activeTabReports"
      >
      </report-panel>
      <div class="row m-2">
        <div class="col-xl-9">
          <form-editor-edit
            :data="data"
            :model="formModel"
            @updateModelItem="handlerUpdateModelItem"
            @change="handleFormData"
            ref="Form"/>
          <more-quotes-grid
            :data="data"
            :listSelectedQuotes.sync="listMoreQuotes"
          ></more-quotes-grid>
        </div>
        <div class="col-xl-3 vb-xl">
          <div class="row">
            <div class="col-xl-12 col-md-auto col-12 mb-4">
              <button
                type="button"
                class="btn btn-white btn-size-s btn-mobile-full"
                @click="handleCreateWO"
              >
                {{L10n('create-wo')}}
              </button>
            </div>
            <div class="col-xl-12 col-md-auto col-12 mb-4">
              <button
                type="button"
                class="btn btn-white btn-size-s btn-mobile-full"
                @click="handleCreateSupplierPO"
              >
                {{L10n('create-supplier-po')}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <modal-create-po
        ref="dialogCreatePO"
        :actionName="actionName"
        :listSelectedQuotes.sync="listMoreQuotes"
        :dataRFQ2="formData"
        @on-created-po="goToChosenTrue"
      >
      </modal-create-po>
    </template>
    <form-controls
      class="form-footer m-4"
      :isCancel="!isAvailableToSave"
      :isCreate="!hasCreateNew"
      :isSave="hasCreateNew"
      @command="setCommand"/>
  </div>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { api } from '@/services/api'
import { getDefaultRFQID } from '@/utils/shared'

export default {
  name: 'SupplierQuoteRFQEditor',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-editor-edit': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './FormEdit.vue'),
    'more-quotes-grid': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierMoreQuotesGrid/Index.vue'),
    'form-editor-new': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './FormNew.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'modal-create-po': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './ModalCreatePO.vue'),
    'report-panel': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierQuotesReports/Index.vue')
  },
  props: {
    config: { type: Object }
  },
  data () {
    return {
      actionName: 'create-wo',
      activeTabReports: 'special-instructions',
      isVisibleReports: false,
      listMoreQuotes: [],
      // eslint-disable-next-line
      apiPatch: 'RFQ2s/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      let mainFields = {
        id: '',
        rfqid: getDefaultRFQID(),
        supplierCompanyID: null,
        employeeID: this.$store.getters.get('currentUser').employeeID,
        entryDate: new Date(),
        partID: null,
        conditionID: null,
        qty: 1,
        price: '',
        currencyID: null
      }
      let editFields = {
        partSN: '',
        paymentTermID: null,
        priceMax: '',
        priceMin: '',
        releaseID: null,
        supplierContactID: null,
        // Only for a chosen grid
        partNumber: '',
        conditionTitle: '',
        currencyTitle: ''
      }
      return this.hasCreateNew ? Object.assign(mainFields, editFields) : mainFields
    },
    handleCreateWO () {
      this.actionName = 'create-wo'
      this.validateAndOpenDialog()
    },
    handleCreateSupplierPO () {
      this.actionName = 'create-supplier-po'
      this.validateAndOpenDialog()
    },
    validateAndOpenDialog () {
      this.$refs.Form.validate()
        .then(() => {
          this.$refs.dialogCreatePO.open()
        })
    },
    goToChosenTrue (rfqID, salesOrderID) {
      let query = { 'supplier-quotes-rfq2-chosen-true': `edit[${salesOrderID}]` }
      this.$router.replace({ name: 'SupplierPoWoOpen', query })
    },
    handleChangeData () {
      this.$emit('change-data', this.data)
      this.listMoreQuotes = []
      if (this.hasCreateNew && this.data.chosen) {
        this.goToChosenTrue(this.data.id)
      }
    },
    gridPatchHandler () {
      this.isLoading = false
    },
    gridCreateHandler () {
      this.isLoading = false
    },
    // TODO FROM MIXIN
    requestGetData () {
      if (this.currentID) {
        this.isLoading = true
        let select = [
          'id', 'rfqid', 'qty', 'partID', 'part.partNumber as partNumber', 'partSN', 'conditionID',
          'condition.title as conditionTitle', 'price', 'currency.title as currencyTitle',
          'supplierCompanyID', 'entryDate', 'currencyID', 'paymentTermID', 'priceMax',
          'priceMin', 'releaseID', 'supplierContactID', 'chosen', 'employeeID'
        ]
        let params = {
          'select': select.join(','),
          'filter': `id == ${this.currentID}`
        }
        api
          .get(`${this.api}`, { requestId: `FormGet-${this._uid}`, params })
          .then(response => {
            this.handleRequestGetData(response.data.value[0])
          })
          .catch(error => {
            // eslint-disable-next-line
            console.error(error)
          })
      }
    }
  }
}
</script>
